import React, { useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import { Grid, Box, Card, CardContent, CardHeader, ToggleButtonGroup, Switch, Dialog, DialogContent, Autocomplete, Input, TableContainer, Table, TableCell, TableBody, TableHead, TableRow, Paper, Typography, useTheme, IconButton, Divider, formControlClasses } from '@mui/material';
import Stack from '@mui/material/Stack';
import { AppBar, Toolbar, } from '@mui/material';
import { Add, Edit, RectangleSharp, SaveOutlined, Shower, Today } from '@mui/icons-material';
import { tokens } from "../../theme/theme";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SwipeableViews from 'react-swipeable-views';
import { FormControl } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import useAutocompleteData from '../../pages/commonapicall/useAutocompleteData'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox } from '@mui/material';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Tooltip from '@mui/material/Tooltip';
import DescriptionIcon from '@mui/icons-material/Description';
import Header from "../../Layout/Header";
import Infoicon from '@mui/icons-material/Info';
import { FormHelperText } from '@mui/material';
import Backicon from '@mui/icons-material/ArrowBack';
import CustomSnackbar from '../../components/CustomSnackbar';
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import { API_ENDPOINTS } from '../../config/api/apiCall';
import Search from '@mui/icons-material/Search';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import Transfer from '@mui/icons-material/MoveUp';
import TransferLocation from '@mui/icons-material/LocationOnOutlined';
import SendIcon from '@mui/icons-material/Send';
import DeleteOutlineIcon from '@mui/icons-material/Delete';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import FileDownloadDoneOutlinedIcon from '@mui/icons-material/FileDownloadDoneOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AddIcon from '@mui/icons-material/Add';
import AddiconOutlined from '@mui/icons-material/AddCircle';
import CreateIcon from '@mui/icons-material/Create';
import Saveicon from '@mui/icons-material/SaveOutlined';
import CancelIcon from '@mui/icons-material/Close';
import Approveicon from '@mui/icons-material/Approval';
import Printicon from '@mui/icons-material/PrintOutlined';
import Amendicon from '@mui/icons-material/AutorenewOutlined';
import List from '@mui/icons-material/List';
import CancelIcon1 from '@mui/icons-material/Cancel';
import Order from '@mui/icons-material/FormatIndentIncrease';
import dayjs from 'dayjs';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Draggable from 'react-draggable';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import GlobalConfig from '../../components/GlobalConfig';
import { useNavigate } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from "@mui/icons-material/Search";
import Chip from '@mui/material/Chip';
import { styled } from '@mui/system';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import DvrIcon from '@mui/icons-material/Dvr';
import CollectionsIcon from '@mui/icons-material/Collections';
import PaddingIcon from '@mui/icons-material/Padding';
import { ShoppingCart, LocalMall, Description } from '@mui/icons-material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { debounce } from 'lodash';
import {
    GridRowModes,
    GridToolbarContainer,
    GridActionsCellItem,
    GridRowEditStopReasons,
} from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import axios from 'axios';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Close from '@mui/icons-material/Close';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const PartyMaster = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const currentDate = dayjs(); // Current date    
    const history = useNavigate();
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [FromCODate, setFromCODate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToCODate, setToCODate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [OrderDate, setOrderDate] = useState(dayjs());
    const [minInvoiceDate, set_minInvoiceDate] = useState(dayjs());
    const [ScheduleDate, setScheduleDate] = useState(dayjs());
    const [Remarks, SetRemarks] = useState('');
    const [isVisible_DespatchPlan, setisVisible_DespatchPlan] = useState(true);
    const [isVisible_CreateDespatchPlan, setisVisible_CreateDespatchPlan] = useState(false);
    const [isVisible_CreateDespatchPlanEntry, setiisVisible_CreateDespatchPlanEntry] = useState(false);
    const [isVisible_DespatchItem, setisVisible_DespatchItem] = useState(false);
    const [isVisible_commanButtons, setisVisible_commanButtons] = useState(false);
    const [isVisible_cancelDetail, setisVisible_cancelDetail] = useState(false);
    const [isVisiblebtnCreateDespatchPlan, setisVisiblebtnCreateDespatchPlan] = useState(true);
    const [isVisiblebtnAddSelectedCO, setisVisiblebtnAddSelectedCO] = useState(false);
    const [isVisibleReelItem, setisVisibleReelItem] = useState(false);
    const [isVisibleSheetItem, setisVisibleSheetItem] = useState(false);
    const [fromModule, SetfromModule] = useState('');
    const [fromSubModule, SetfromSubModule] = useState('');
    const [headerDespatchplan, SetheaderDespatchplan] = useState('New Party');
    const [btnApprove, setbtnApprove] = useState(false);
    const [btnSaveUpdate, setbtnSaveUpdateOrdershow] = useState(false);
    const [btnAmendment, setbtnAmendmentshow] = useState(false);
    const [btnPrint, setbtnPrint] = useState(false);
    const [btnCancel, setbtnCancel] = useState(false);
    const [btnGenerateInvoice, set_btnGenerateInvoice] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');
    const [btnSaveText, setbtnSaveText] = useState('Save');
    const [btnSaveTooltip, setbtnSaveTooltip] = useState('Save Invoice');
    const [openAlert, setOpenAlert] = useState(false);
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
    const [loading, setLoading] = React.useState(false);
    const [rows, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [rowsConfirmedOrders, setrowsConfirmedOrders] = useState([]);
    const [filteredData_ConfirmedOrders, setFilteredData_ConfirmedOrders] = useState([]);
    const [searchText_ConfirmedOrders, setSearchText_ConfirmedOrders] = useState('');
    const [selectCOOrders, setselectCOOrders] = useState([]);
    const [Reason, SetReason] = useState('');
    const [cancelDate, setSelectedDate] = React.useState();
    const [ReasonError, setReasonError] = useState("");
    const [DateError, setDateError] = useState("");
    const [SAmendmentReason, SetSAmendmentReason] = useState('');
    const [visibleAmendmentReason, setvisibleAmendmentReason] = useState(false);
    const [amendReasonError, setamendReasonError] = useState("");
    const [selectedCOIds, setSelectedCOIds] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [SInvoiceNo, SetSInvoiceNo] = useState('');
    const [DespatchNoAF, SetDespatchNoAF] = useState(false);
    const [SLength, SetSLength] = useState('');
    const [iDeliveryOrderId, setiDeliveryOrderId] = useState(0);
    const [iInvoiceOrderId, setiInvoiceOrderId] = useState(0);
    const [iIndentID, setiIndentID] = useState(0);
    const [iConfirmationID, setiConfirmationID] = useState(0);
    const [iDespatchPlanID, setiDespatchPlanID] = useState(0);
    const [SRefNo, SetSRefNo] = useState('');
    const [selectedCountry, setSelectedCountry] = useState('');
    const [SCountry, setSCountry] = useState(0);
    const [transporterError, settransporterError] = useState("");
    const [selectedPartyRole, setSelectedPartyRole] = useState('');

    const [selectedParentCompany, setSelectedParentCompany] = useState('');
    const [selectedSalesPerson, setSelectedSalesPerson] = useState('');


    const [customerAddress, setcustomerAddress] = useState("");
    const [supplierAddress, setsupplierAddress] = useState("");
    const [billToCustomerError, setBillToCustomerError] = useState("");
    const [shipToCustomerError, setshipToCustomerError] = useState("");
    const [priceListError, setpriceListError] = useState("");
    const [indentdateError, setindentdateError] = useState("");
    const [PartyRoleid, setPartyRole] = useState('');

    const [SParentCompany, setParentCompany] = useState(0);
    const [SSalesPerson, setSalesPerson] = useState(0);


    const [selectedPartyType, setSelectedPartyType] = useState('');
    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState('');
    const [selectedCreditTerm, setSelectedCreditTerm] = useState('');
    const [selectedCreditTermRule, setSelectedCreditTermRule] = useState('');
    const [Id_PartyType, setId_PartyType] = useState(null);
    const [Id_PaymentTerm, setId_PaymentTerm] = useState(null);
    const [Id_CreditTerm, setId_CreditTerm] = useState(null);
    const [Id_CreditTermRule, setId_CreditTermRule] = useState(null);
    const [totalSIConfirmedQty, set_totalSIConfirmedQty] = useState(0);
    const [totalGrossAmount, set_totalGrossAmount] = useState(0);
    const [totaldiscountAmount, settotaldiscountAmount] = useState(0);
    const [totalAmount, settotalAmount] = useState(0);
    const [IParentInvoiceOrder_ID, set_IParentInvoiceOrder_ID] = useState(0);
    const [iDespatchOrderIdList, set_iDespatchOrderIdList] = useState(0);
    const [iShippedOrderIdList, set_iShippedOrderIdList] = useState(0);
    const [iInvoiceOrderIdList, set_iInvoiceOrderIdList] = useState(0);
    const [iConfirmationIdList, set_iConfirmationIdList] = useState(0);
    const [DocumentSeries, SeDocumentSeries] = useState(12);
    const [bOrderInvoiced, set_bOrderInvoiced] = useState(false);
    const masterGroup = '';
    const [selectedOrders, setSelectedOrders] = useState([]);
    const isSelected = (orderId) => selectedOrders.indexOf(orderId) !== -1;
    const [gridAutoRows, setGridAutoRows] = useState(calculateGridAutoRows());
    const [open, setOpen] = useState(false);
    var sSelectedConfirmationIDList;
    var sSelectedItemIDList;
    let [FinancierYear, setFinancierYear] = useState(1);
    let [LOGIN_USER, setLOGIN_USER] = useState('');
    let [CompanyID] = useState(1);
    const [cancelReasonFoucs, SetcancelReasonFoucs] = useState(false);
    const [amendmentReasonFoucs, SetamendmentReasonFoucs] = useState(false);

    const commonParams = {
        FinancierYear,
        masterGroup,
    };
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleSelectPartyType = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedPartyType(newValue);
            setId_PartyType(newValue.CodeId);
        }
    };

    const handleSelectPaymentTerm = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedPaymentTerm(newValue);
            setId_PaymentTerm(newValue.CodeId);
        }
    };

    const handleSelectCreditTerm = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedCreditTerm(newValue);
            setId_CreditTerm(newValue.CodeId);
        }
    };

    const handleSelectCreditTermRule = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedCreditTermRule(newValue);
            setId_CreditTermRule(newValue.CodeId);
        }
    };

    const handleSelectPoNo = (e) => {
        SetSRefNo(e.target.value);
    }



    const handleSelectParentCompany = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedParentCompany(newValue);
            setParentCompany(newValue.CodeId);

            if (dataSalesPerson.length > 0) {
                const codeIdValue = newValue.CodeId;
                const stringCodeIdValue = String(codeIdValue);
                const filteredData = dataSalesPerson.filter((item) => item.CodeId === stringCodeIdValue);

                if (filteredData.length > 0) {
                    setSelectedSalesPerson(filteredData[0]);
                    setSalesPerson(newValue.CodeId);
                }
            }
        }
    };

    const handleSelectSalesPerson = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedSalesPerson(newValue);
            setSalesPerson(newValue.CodeId);
        }
    };

    const fetchAddressData = (SPartyID, SPartyAddressType) => {
        const cls_Party = { SPartyID, SPartyAddressType };

        return fetch(API_ENDPOINTS.getPartyAddress, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cls_Party)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to get the address..!');
                }
                return response.json();
            });
    };

    const getAddressString = (data) => {
        return `Address: ${data[0].LabelValueColumn2}, ${data[1].LabelValueColumn2} | State: ${data[2].LabelNameColumn2} | City: ${data[2].LabelValueColumn2} | Postal Code: ${data[3].LabelValue}`;
    };

    const handleSelectCountry = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedCountry(newValue);
            setSCountry(newValue.CodeId);
        }
    };


    const handleSelectPartyRole = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedPartyRole(newValue);
            setPartyRole(newValue.CodeId);
            setOpenAlert(false);
        }
    };

    const useAutocompleteDataByMasterGroup = (masterGroup) => {
        const data = useAutocompleteData(
            API_ENDPOINTS.GET_MASTER_LIST,
            {
                ...commonParams,
                masterGroup: masterGroup,
            }
        );
        return data;
    };


    const dataPartyRole = useAutocompleteDataByMasterGroup('PARTY_ROLE');
    const dataPartyType = useAutocompleteDataByMasterGroup('PARTY_TYPE');
    const dataPaymentterm = useAutocompleteDataByMasterGroup('SO_PAYMENT_TERM');
    const dataCreditterm = useAutocompleteDataByMasterGroup('SO_CREDIT_TERM');
    const dataCredittermRule = useAutocompleteDataByMasterGroup('SO_CREDIT_LIMIT_RULE');

    const dataParentCompany = useAutocompleteDataByMasterGroup('PARTY_PARENT_COMPANY');
    const dataSalesPerson = useAutocompleteDataByMasterGroup('SO_SALESPERSON');
    const dataCountry = useAutocompleteDataByMasterGroup('COUNTRY');

    const filterData = (data) => {
        const filtered = data.filter(row =>
            Object.values(row).some(value =>
                value && value.toString().toLowerCase().includes(searchText.toLowerCase())
            )
        );
        setFilteredData(filtered);
    };

    const LoadPartyList = () => {

        setLoading(true); // Set loading state to true before fetching data

        const PartyIdList = 'All';

        fetch(API_ENDPOINTS.LoadPartyList, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(PartyIdList)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load party details');
                }
                return response.json();
            })
            .then(data => {
                const formattedData = data.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setTableData(formattedData);
            })
            .catch(error => {
                showError('Unable to load party details', 'error');
            })
            .finally(() => {
                setLoading(false); // Set loading state to false after fetching data
            });
    };
    const debouncedLoadInoviceOrderList = debounce(LoadPartyList, 500);
    const filterData_ConfirmedOrders = (data) => {
        const filtered = data.filter(row =>
            Object.values(row).some(value =>
                value && value.toString().toLowerCase().includes(searchText_ConfirmedOrders.toLowerCase())
            )
        );
        setFilteredData_ConfirmedOrders(filtered);
    };

    const LoadConfirmedOrderList = () => {
        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        } else {

            const formattedFromDate = dayjs(FromCODate).format('YYYY-MMM-DD');
            const formattedToDate = dayjs(ToCODate).format('YYYY-MMM-DD');

            const requestBody = {
                SearchType: '',
                SearchString: '',
                SInvoiceNo: '',
                InvoiceDateFrom: formattedFromDate,
                InvoiceDateTo: formattedToDate,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: CompanyID,
                },
            };

            fetch(API_ENDPOINTS.LoadInvoiceOrder_Combined_Invoice, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load confirmation order details');
                    }
                    return response.json();
                })
                .then(data => {
                    const formattedData = data.map((row, index) => {
                        const dateOnly = new Date(row.ConfirmationDate).toLocaleDateString();
                        const ShippedOrderDate = new Date(row.ShippedOrderDate).toLocaleDateString();
                        return { ...row, id: index + 1, dateOnly, ShippedOrderDate };
                    });

                    setrowsConfirmedOrders(formattedData);
                })
                .catch(error => {
                    showError('Unable to load confirmation order details', 'error');
                });
        }
    };

    const showSnackbar = () => {
        setSnackbarOpen(true);
    };

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        debouncedLoadInoviceOrderList();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        debouncedLoadInoviceOrderList();
    };

    const handleFromCODate = (date) => {
        setFromCODate(dayjs(date));
        LoadConfirmedOrderList();
    };

    const handleToCODate = (date) => {
        setToCODate(dayjs(date));
        LoadConfirmedOrderList();
    };
    const handlerOrderDate = (date) => {
        setOrderDate(dayjs(date));
    };
    const handleScheduleDate = (date) => {
        setScheduleDate(dayjs(date));
    };

    const handleCreateDispatchPlans = () => {
        setisVisible_CreateDespatchPlan(true);
        setisVisible_DespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(true);
        setisVisible_DespatchItem(false);
        SetfromModule('Invoice Order List')

        setisVisiblebtnCreateDespatchPlan(true);
        setisVisiblebtnAddSelectedCO(false);
    };

    const LoadDespatchOrderDetail = (requestBody, status) => {
        fetch(API_ENDPOINTS.loadDespatchOrderDetail, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load despatch plan details');
                }
                return response.json();
            })
            .then(data => {
                SetheaderDespatchplan(data.SOrderStatus + " despatch plan");
                SetSInvoiceNo('Auto');
                setOrderDate(data.SDespatchOrderDate);

                if (data.SScheduledDate !== null) {
                    setScheduleDate(data.SScheduledDate);
                }
                SetRemarks(data.SRemarks);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsConfirmedOrdersDespacth(fdata);

                const fdata1 = data.DespatchPlanReelOrdersList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsReelItems(fdata1);

                const fdata2 = data.DespatchPlanSheetOrdersList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsSheetItems(fdata2);

                const fdata3 = data.DespatchPlanQtySummary.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setplannedQtyData(fdata3);

                RefreshStatus(status);
                setisVisible_cancelDetail(false);
            })
            .catch(error => {
                setAlertMessage('Unable to load despatch plan details');
                setalertsevierity('error');
                showSnackbar();
            });
    }

    const LoadConfirmationOrderDetailForDespatchOrder = (requestBody) => {
        fetch(API_ENDPOINTS.LoadInvoiceOrder_Combined_Invoice_for_CreateInvoice, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to create the invoice');
                }
                return response.json();
            })
            .then(data => {
                SetSInvoiceNo(data.SInvoiceNo);
                set_iInvoiceOrderIdList(data.InvoiceOrderIdList);
                set_iConfirmationIdList(data.ConfirmationOrderIdList);
                if (data.SParentInvoiceOrder_ID === 0) {
                    data.SOrderStatus = "[New]"
                }
                set_IParentInvoiceOrder_ID(data.SParentInvoiceOrder_ID);
                if (data.SInvoiceNo != '') {
                    set_bOrderInvoiced(true);
                }

                if (data.SInvoiceDate != null) {
                    setOrderDate(data.SInvoiceDate);
                }

                set_minInvoiceDate(data.SShipmentPlanDate);

                handleFilterAndSetSelection(dataParentCompany, setSelectedParentCompany, 'SBillToCustomer', data, setParentCompany);
                handleFilterAndSetSelection(dataSalesPerson, setSelectedSalesPerson, 'SShipToCustomer', data, setSalesPerson);
                handleFilterAndSetSelection(dataPartyRole, setSelectedPartyRole, 'SPriceList', data, setPartyRole);

                handleFilterAndSetSelection(dataPartyType, setSelectedPartyType, 'SShipmentMode', data, setId_PartyType);
                handleFilterAndSetSelection(dataPaymentterm, setSelectedPaymentTerm, 'SPaymentTerm', data, setId_PaymentTerm);
                handleFilterAndSetSelection(dataCreditterm, setSelectedCreditTerm, 'SCreditTerm', data, setId_CreditTerm);
                handleFilterAndSetSelection(dataCredittermRule, setSelectedCreditTermRule, 'SCreditLimitRule', data, setId_CreditTermRule);

                if (data.SScheduledDate !== null) {
                    setScheduleDate(data.SScheduledDate);
                }

                SetRemarks(data.SRemarks);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsConfirmedOrdersDespacth(fdata);
                RefreshStatus(data.SOrderStatus);
                SetfromModule('Invoice Ordes');
                setbtnCancel(false);
                setbtnApprove(false);
            })
            .catch(error => {
                showError('Unable to create the invoice', 'error');
            });
    }

    function validateForm() {
        let isFormDataValid = true;

        if (rowsConfirmedOrders.length === 0) {
            showError("Please select the order items to include in the Invoice Plan", "error");
            return false;
        }

        const selectedRows = rowsConfirmedOrders.filter(row => row.SelectItem);
        const distinctBillToCustomers = [...new Set(selectedRows.map(row => row.BillToCustomer))];
        const distinctShipToCustomers = [...new Set(selectedRows.map(row => row.ShipToCustomer))];

        if (selectedRows.length > 1 && (distinctBillToCustomers.length > 1 || distinctShipToCustomers.length > 1)) {
            showError("Bill To and Ship To Customers should be same", "error");
            isFormDataValid = false;
        }
        return isFormDataValid;
    }

    const handleShowDispatchPlansEntry = () => {
        if (validateForm() != false) {
            let selectedDPIds = [];
            let selectedDOIDs = [];
            let selectedIOIds = [];
            let selectedCOIdsNew = [];

            selectCOOrders.forEach((oItemRow) => {
                if (!selectedDPIds.includes(parseInt(oItemRow.DespatchPlanId))) {
                    selectedDPIds.push(parseInt(oItemRow.DespatchPlanId));
                }
                selectedDOIDs.push(parseInt(oItemRow.DeliveryOrderId));
                selectedIOIds.push(parseInt(oItemRow.InvoiceOrderId));
                selectedCOIdsNew.push(parseInt(oItemRow.ConfirmationOrderId));
            });

            setiConfirmationID(selectedCOIdsNew);
            setiDespatchPlanID(selectedDPIds);
            setiDeliveryOrderId(selectedDOIDs);
            setiInvoiceOrderId(selectedIOIds);

            if (selectedDOIDs.length === 0) {
                showError('Please select the order items to include in the despatch plan', 'warning');
                return;
            }
            const sListDPIds = selectedDPIds.join(',');
            const sListDOIDs = selectedDOIDs.join(',');
            const sListIOIds = selectedIOIds.join(',');
            const sListCOIDs = selectedCOIdsNew.join(',');

            set_iDespatchOrderIdList(sListDPIds);
            set_iShippedOrderIdList(sListDOIDs);
            set_iInvoiceOrderIdList(sListIOIds);
            set_iConfirmationIdList(sListCOIDs);

            if (sListIOIds != "") {
                const requestBody = {
                    DespatchOrderIdList: sListDPIds,
                    ShippedOrderIdList: sListDOIDs,
                    InvoiceOrderIdList: sListIOIds,
                    ConfirmationOrderIdList: sListCOIDs,
                    ConstructedGlobalValues: {
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: CompanyID,
                    },
                };
                LoadConfirmationOrderDetailForDespatchOrder(requestBody);
            }
        }

    };

    const handleViewReport = async () => {
        try {

            if (headerDespatchplan === 'Invoiced Order List') {

                const requestBody = {
                    I_ParentInvoiceOrder_ID: IParentInvoiceOrder_ID,
                    ConstructedGlobalValues: {
                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                        COMPANY_ID: CompanyID,
                    },
                };

                const response = await axios.post(API_ENDPOINTS.InvoiceReportGenerate,
                    requestBody,
                    {
                        responseType: 'arraybuffer' // Important to receive binary data
                    }
                );

                // Extract INVO5 object from response headers             

                // Handle the binary data response as before
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report.pdf');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                showError('Invoice report exported successfully..!', 'success')

            }
        } catch (error) {
            console.error('Error generating report:', error);
            // Handle error
        } finally {
            setLoading(false);
        }
    };

    const handleBackTofromDespacthPlanEntry = () => {
        setisVisible_CreateDespatchPlan(false);
        setisVisible_DespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setisVisible_DespatchItem(false);

        if (fromModule === 'Invoice Order List') {
            setisVisible_DespatchPlan(true);
        }
        else if (fromModule === 'Invoice Ordes') {
            setisVisible_CreateDespatchPlan(true);
        }
        else if (fromSubModule === 'Despatch Plan Entry') {
            setiisVisible_CreateDespatchPlanEntry(true);
            setisVisible_commanButtons(true);
            SetfromSubModule('');
        }
    }

    const handleCancel = (e) => {
        setisVisible_cancelDetail(true);
        handleCancelInvoice(e);
    }

    const handleOn_OrderItemsCellClick = (params, event) => {
        const iConfirmationID = params.row.SOrderConfirmationId;
        const iProductID = params.row.SProductID;

        var updatedDespatchPlanReelStockAvailable1;
        if (params.row.SILength === 0) {
            updatedDespatchPlanReelStockAvailable1 = rowsReelItems.filter(pItemNew => {
                return (
                    (pItemNew.ConfirmationOrderID === iConfirmationID && pItemNew.ProductID === iProductID) ||
                    (pItemNew.OrderRefNo === "SWO" && pItemNew.ProductID === iProductID && (pItemNew.ConfirmationOrderID === iConfirmationID || pItemNew.ConfirmationOrderID === 0))
                );
            });
            setrowsReelItemsFiltered(updatedDespatchPlanReelStockAvailable1);
        }

        else {
            updatedDespatchPlanReelStockAvailable1 = rowsSheetItems.filter(pItemNew => {
                return (
                    (pItemNew.ConfirmationOrderID === iConfirmationID && pItemNew.ProductID === iProductID) ||
                    (pItemNew.OrderRefNo === "SWO" && pItemNew.ProductID === iProductID && (pItemNew.ConfirmationOrderID === iConfirmationID || pItemNew.ConfirmationOrderID === 0))
                );
            });
            setrowsSheetItemsFiltered(updatedDespatchPlanReelStockAvailable1);
        }

        if (params.row.SILength === 0) {
            setisVisibleReelItem(true);
            setisVisibleSheetItem(false);
        }
        else {
            setisVisibleSheetItem(true);
            setisVisibleReelItem(false);
        }
        SetSLength(params.row.SILength);
        setisVisible_CreateDespatchPlan(false);
        setisVisible_DespatchPlan(false);
        setisVisible_DespatchItem(true);
        setisVisible_commanButtons(true);
        SetfromSubModule('Despatch Plan Entry');
        handleOpen();
    };

    const handleBackTofromConnfrimOrderList = () => {
        setisVisible_CreateDespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setisVisible_DespatchItem(false);
        setisVisible_DespatchPlan(true);
    }

    const handleOnCellClick = (params, event) => {
        const status = params.row.InvoiceStatus;
        let selectedDPIds = [];
        let selectedDOIDs = [];
        let selectedIOIds = [];
        let selectedCOIdsNew = [];

        set_IParentInvoiceOrder_ID(params.row.InvoicePlanNo);
        setiIndentID(params.row.IndentId);
        setiConfirmationID(params.row.ConfirmationOrderId);
        setiDespatchPlanID(params.row.DespatchPlanId);
        setiDeliveryOrderId(params.row.DeliveryOrderId);
        setiInvoiceOrderId(params.row.InvoiceOrderId);

        // Iterate over rows and update local variables
        rows.forEach((oItemRow) => {
            if (parseInt(oItemRow.InvoicePlanNo) === params.row.InvoicePlanNo) {
                if (!selectedDPIds.includes(parseInt(oItemRow.DespatchPlanId))) {
                    selectedDPIds.push(parseInt(oItemRow.DespatchPlanId));
                }
                selectedDOIDs.push(parseInt(oItemRow.DeliveryOrderId));
                selectedIOIds.push(parseInt(oItemRow.InvoiceOrderId));
                selectedCOIdsNew.push(parseInt(oItemRow.ConfirmationOrderId));
            }
        });

        // Convert array of selected IDs to comma-separated strings
        const sListDPIds = selectedDPIds.join(',');
        const sListDOIDs = selectedDOIDs.join(',');
        const sListIOIds = selectedIOIds.join(',');
        const sListCOIDs = selectedCOIdsNew.join(',');

        set_iDespatchOrderIdList(sListDPIds);
        set_iShippedOrderIdList(sListDOIDs);
        set_iInvoiceOrderIdList(sListIOIds);
        set_iConfirmationIdList(sListCOIDs);

        if (params.row.InvoicePlanNo > 0) {
            const requestBody = {
                IParentInvoiceOrder_ID: params.row.InvoicePlanNo,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: CompanyID,
                    LOGIN_USER: LOGIN_USER
                },
            };
            LoadInvoiceOrder_Combined_Invoice_Print(requestBody, status)
        }

        // LoadDespatchOrderDetail(requestBody, status);
        SetfromModule('Invoice Order List');
        setbtnSaveText('Update');
        setbtnSaveTooltip('Update Invoice');
        SetDespatchNoAF(true);
    };

    const handleFilterAndSetSelection = (dataArray, setValueFunction, codeIdField, data, setCodeId) => {
        if (dataArray.length > 0) {
            const codeIdValue = data?.[codeIdField];
            const stringCodeIdValue = String(codeIdValue);
            const filteredData = dataArray.filter((item) => item.CodeId === stringCodeIdValue);

            if (filteredData.length > 0) {
                setValueFunction(filteredData[0]);
                setCodeId(codeIdValue);
            }
        }
    };

    const LoadInvoiceOrder_Combined_Invoice_Print = (requestBody, status) => {
        fetch(API_ENDPOINTS.LoadInvoiceOrder_Combined_Invoice_Print, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load invoice order for update');
                }
                return response.json();
            })
            .then(data => {
                SetheaderDespatchplan(data.SOrderStatus + " Invoice Order");
                SetSInvoiceNo(data.SInvoiceNo);
                set_IParentInvoiceOrder_ID(data.SParentInvoiceOrder_ID);

                if (data.SInvoiceNo && data.SInvoiceNo.trim() !== "") {
                    set_bOrderInvoiced(true);
                }
                if (data.SInvoiceDate != null) {
                    setOrderDate(data.SInvoiceDate);
                }

                set_minInvoiceDate(data.SShipmentPlanDate);

                handleFilterAndSetSelection(dataParentCompany, setSelectedParentCompany, 'SBillToCustomer', data, setParentCompany);
                handleFilterAndSetSelection(dataSalesPerson, setSelectedSalesPerson, 'SShipToCustomer', data, setSalesPerson);
                handleFilterAndSetSelection(dataPartyRole, setSelectedPartyRole, 'SPriceList', data, setPartyRole);

                handleFilterAndSetSelection(dataPartyType, setSelectedPartyType, 'SShipmentMode', data, setId_PartyType);
                handleFilterAndSetSelection(dataPaymentterm, setSelectedPaymentTerm, 'SPaymentTerm', data, setId_PaymentTerm);
                handleFilterAndSetSelection(dataCreditterm, setSelectedCreditTerm, 'SCreditTerm', data, setId_CreditTerm);
                handleFilterAndSetSelection(dataCredittermRule, setSelectedCreditTermRule, 'SCreditLimitRule', data, setId_CreditTermRule);

                if (data.SScheduledDate !== null) {
                    setScheduleDate(data.SScheduledDate);
                }
                SetRemarks(data.SRemarks);
                SetSRefNo(data.SRefNo);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    const SShipmentPlanDate = new Date(row.SShipmentPlanDate).toLocaleDateString();
                    return { ...row, id: index + 1, SShipmentPlanDate };
                });

                setrowsConfirmedOrdersDespacth(fdata);

                const fdata3 = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setplannedQtyData(fdata3);

                RefreshStatus(status);
                setisVisible_cancelDetail(false);
                CalculateSummaryForProducts();
            })
            .catch(error => {

                showError('Unable to load invoice order for update', 'error');
            });
    }

    const CalculateSummaryForProducts = () => {
        let totalSIConfirmedQty = 0;
        let totalGrossAmount = 0;
        let oTotalDiscountAmount = 0;

        rowsConfirmedOrdersDespacth.forEach((row) => {
            const newRowSIConfirmedQty = parseFloat(row.SIConfirmed_Qty);
            const newRowSIUnitPrice = parseFloat(row.SIUnitPrice);
            const newRowSIDiscount = parseFloat(row.SIDiscount);
            const DiscountType = row.SIDiscountType;

            if (newRowSIDiscount > 0) {
                if (DiscountType === 'rate') {
                    oTotalDiscountAmount += newRowSIConfirmedQty * ((newRowSIUnitPrice * newRowSIDiscount) / 100)
                }
                else {
                    oTotalDiscountAmount += newRowSIConfirmedQty * newRowSIDiscount
                }
            }
            totalSIConfirmedQty += newRowSIConfirmedQty;
            totalGrossAmount += newRowSIConfirmedQty * newRowSIUnitPrice;
        });

        // Set the totals in the state
        set_totalSIConfirmedQty(totalSIConfirmedQty);
        set_totalGrossAmount(totalGrossAmount);
        settotaldiscountAmount(oTotalDiscountAmount);
        settotalAmount(oTotalDiscountAmount);
    }

    const RefreshStatus = (status) => {
        setbtnApprove(false);
        setbtnSaveUpdateOrdershow(false);
        setbtnAmendmentshow(false);
        setbtnPrint(false);
        setbtnCancel(false);
        setvisibleAmendmentReason(false);
        set_btnGenerateInvoice(false);

        if (status === 'New' || status === '[New]') {
            SetheaderDespatchplan('New Party')
            setbtnSaveUpdateOrdershow(true);
            setbtnCancel(true);
            setbtnApprove(true);
        }
        else if (status === 'Processed') {
            SetheaderDespatchplan('Invoice Order in Process')
            setbtnPrint(true);
        }
        else if (status === 'UnderAmendment') {
            SetheaderDespatchplan('Amended Invoice Order')
            setbtnSaveUpdateOrdershow(true);
            setbtnCancel(true);
            setbtnApprove(true);
        }
        else if (status === 'Cancelled') {
            SetheaderDespatchplan('Invoice Order Cancelled')
        }
        else if (status === 'Approved') {
            SetheaderDespatchplan('Approved Invoice Order')
            setbtnCancel(true);
            setbtnAmendmentshow(true);
            setvisibleAmendmentReason(true);
            set_btnGenerateInvoice(true);
        }
        else if (status === 'Invoiced') {
            SetheaderDespatchplan('Invoiced Order List')
            setbtnCancel(true);
            setbtnPrint(true);
            setbtnAmendmentshow(true);
            setvisibleAmendmentReason(true);
        }
        setisVisible_CreateDespatchPlan(false);
        setisVisible_DespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(true);
        setisVisible_commanButtons(true);
        setisVisible_DespatchItem(false);
    }

    const handleEnterReason = (e) => {
        SetReason(e.target.value);
    }
    const handleDateChange = (date) => {
        const selectedDate = new Date(date); // Assuming 'date' is a valid date string
        const formattedDate = selectedDate.toLocaleDateString('en-US');
        setSelectedDate(formattedDate);
    };

    const handleSelectAmendmentReason = (e) => {
        SetSAmendmentReason(e.target.value);
    }
    const handleEditClick = (id) => () => {

        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });

    };

    const handleSaveClick = (id) => () => {

        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
        CalculateSummaryForProducts();

    };

    const handleDeleteClick = (id) => () => {
        setrowsConfirmedOrdersDespacth(rowsConfirmedOrdersDespacth.filter((row) => row.id !== id));
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rowsConfirmedOrdersDespacth.find((row) => row.id === id);
        if (editedRow.isNew) {
            setrowsConfirmedOrdersDespacth(rowsConfirmedOrdersDespacth.filter((row) => row.id !== id));
        }
    };


    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        setrowsConfirmedOrdersDespacth(rowsConfirmedOrdersDespacth.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            const id = 0;
            setrowsConfirmedOrdersDespacth((oldRows) => [...oldRows, { id, name: '', age: '', isNew: true }]);
            setRowModesModel((oldModel) => ({
                ...oldModel,
                [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
            }));
        };

        return (
            <GridToolbarContainer>
                {/* <Button color="primary"  onClick={handleClick}>
              Add record
            </Button> */}
            </GridToolbarContainer>
        );
    }


    const columns = [
        {
            field: 'edit', headerName: '', sortable: false, filterable: false, width: 2,
            renderCell: (params) => (
                <Tooltip title="Edit Party Details">
                    <IconButton onClick={() => handleOnCellClick(params)}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
            ),
        },
        { field: 'PartyCode', headerName: 'Code', hide: true, width: 100 },
        { field: 'PartyName', headerName: 'Name', width: 230 },
        { field: 'PartyType', headerName: 'Type', width: 120 },
        { field: 'PartyRoleName', headerName: 'RoleName', width: 120 },
        { field: 'PartyGSTNo', headerName: 'GSTNo', width: 150 },
        { field: 'PartyCreditTerm', headerName: 'CreditTerm', width: 100 },
        { field: 'PartyCreditTermRule', headerName: 'CreditTermRule', width: 100 },
        { field: 'PartyPaymentTerm', headerName: 'PaymentTerm', width: 150 },
        { field: 'PartyParentCompany', headerName: 'ParentCompany', width: 150 },
        { field: 'PartyNotes', headerName: 'Notes', width: 150 },
    ];

    const columnsConfirmedOrders = [
        {
            field: 'SelectItem',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 80,
            // renderHeader: () => (
            //     <Checkbox
            //      onChange={handleSelectAllCheckboxChange_ConfirmationOrder} checked={areAllRowsSelected_ConfirmationOrder()}
            //     />
            // ),
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.SelectItem}
                    onChange={(event) => handleCheckboxChangeForConfirmationOrder(event, params.row.id)}
                />
            )
        },
        { field: 'ShippedOrderNo', headerName: 'DO No', width: 120 },
        { field: 'ShippedOrderDate', headerName: 'DO Date', width: 80 },
        { field: 'ConfirmationNo', headerName: 'CO No', width: 80 },
        { field: 'dateOnly', headerName: 'CO Date', width: 80 },
        { field: 'PartyPONo', headerName: 'Party PO', width: 80 },
        {
            field: 'InvoiceStatus', headerName: 'Invoice Status', width: 160, renderCell: (params) => <StatusCell value={params.value} />, // Use custom cell renderer
        },
        { field: 'BillToCustomer', headerName: 'Bill to Customer', width: 200 },
        { field: 'ShipToCustomer', headerName: 'Ship to Customer', width: 200 },
        { field: 'ShipToCity', headerName: 'City', width: 120 },
        { field: 'ShipToState', headerName: 'State', width: 120 },
    ];

    const [rowsConfirmedOrdersDespacth, setrowsConfirmedOrdersDespacth] = useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});


    const [rowsReelItems, setrowsReelItems] = useState([]);
    const [rowsSheetItems, setrowsSheetItems] = useState([]);
    const [rowsReelItemsFiltered, setrowsReelItemsFiltered] = useState([]);
    const [rowsSheetItemsFiltered, setrowsSheetItemsFiltered] = useState([]);
    const [plannedQtyData, setplannedQtyData] = useState([]);

    const columnsConfirmedOrdersDespacth = [
        {
            field: 'actions',
            type: 'actions',
            headerName: '',
            width: 50,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            color="inherit"
                            onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }
                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"

                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                    />,
                    // <GridActionsCellItem
                    //     icon={<DeleteIcon />}
                    //     label="Delete"
                    //     onClick={handleDeleteClick(id)}
                    //     color="inherit"
                    // />,
                ];
            },
        },

        { field: 'SIVariety', headerName: 'Variety', width: 100 },
        { field: 'SIBF', headerName: 'BF', width: 50 },
        { field: 'SIGSM', headerName: 'GSM', width: 50 },
        { field: 'SIWidth', headerName: 'Width', width: 50 },
        { field: 'SILength', headerName: 'Length', width: 50 },
        { field: 'SIColor', headerName: 'Color', width: 50 },
        { field: 'SIUnit', headerName: 'UOM', width: 50 },
        { field: 'SIRequested_Qty', headerName: 'Requested Qty', width: 90 },
        { field: 'SIUnitPrice', headerName: 'Unit Price', width: 70, editable: true },
        { field: 'SIDiscountType', headerName: 'Discount type', width: 80 },
        { field: 'SIDiscount', headerName: 'Discount / Unit', width: 100 },
        { field: 'SIConfirmed_Qty', headerName: 'Confirmed Qty', width: 100 },
        { field: 'SIShipped_Qty', headerName: 'Shipped Qty', width: 100 },
        { field: 'SIRemarks', headerName: 'Remarks', width: 100 },
        { field: 'SIConfirmationNo', headerName: 'Confirmation No', width: 100 },
        { field: 'SShipmentPlanNo', headerName: 'Shipment Plan No', width: 120 },
        { field: 'SShipmentPlanDate', headerName: 'Shipment Plan Date', width: 120 },

    ];

    const areAllRowsSelected = () => {
        if (SLength > 0) {
            return rowsSheetItemsFiltered.every(row => row.SelectItem);
        } else {
            return rowsReelItemsFiltered.every(row => row.SelectItem);
        }
    };

    const columnsSheetItems = [
        {
            field: 'SelectItem',
            headerName: '',
            width: 80,
            sortable: false,
            filterable: false,
            renderHeader: () => (
                <Checkbox
                    onChange={handleSelectAllCheckboxChange} checked={areAllRowsSelected()}
                />
            ),
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.SelectItem}
                    onChange={(event) => handleCheckboxChange(event, params.row.id)}
                />
            )
        },
        { field: 'OrderRefNo', headerName: 'Stock Ref.', width: 100 },
        { field: 'Variety', headerName: 'Variety', width: 110 },
        { field: 'GSM', headerName: 'GSM', width: 30 },
        { field: 'Width', headerName: 'Width', width: 30 },
        { field: 'Length', headerName: 'Length', width: 30 },
        { field: 'Location', headerName: 'Location', width: 80 },
        { field: 'LotNo', headerName: 'Lot No', width: 70 },
        { field: 'BundleNumber', headerName: 'Bundle Number', width: 150 },
        { field: 'sheetsReam', headerName: 'Sheets/Ream', width: 80 },
        { field: 'WeightPerBundle', headerName: 'Bundle Weight(kg)', width: 120 },

    ];

    const columnsReelItems = [
        {
            field: 'SelectItem',
            headerName: '',
            width: 80,
            sortable: false,
            filterable: false,
            renderHeader: () => (
                <Checkbox
                    onChange={handleSelectAllCheckboxChange}
                    checked={areAllRowsSelected()}
                />
            ),
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.SelectItem}
                    onChange={(event) => handleCheckboxChange(event, params.row.id)}
                />
            )
        },
        { field: 'OrderRefNo', headerName: 'Stock Ref.', width: 100 },
        { field: 'Variety', headerName: 'Variety', width: 110 },
        { field: 'GSM', headerName: 'GSM', width: 30 },
        { field: 'Width', headerName: 'Width', width: 30 },
        { field: 'Length', headerName: 'Length', width: 30 },
        { field: 'Location', headerName: 'Location', width: 80 },
        { field: 'LotNo', headerName: 'Lot No', width: 70 },
        { field: 'ReelNumber', headerName: 'Reel Number', width: 150 },
        { field: 'ReelWeight', headerName: 'Reel Weight(kg)', width: 120 },

    ];

    const SizeCell = ({ row }) => {
        const size = `${row.Width} x ${row.Length}`;

        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                {size}
            </div>
        );
    };
    // Function to calculate percentage
    const calculatePercentage = (plannedQty, confirmedQty) => {
        return (plannedQty / confirmedQty) * 100;
    };

    // Custom cell renderer for Filled Qty column
    const FilledQtyCell = ({ row }) => {
        const percentage = calculatePercentage(row.PlannedQty, row.ConfirmedQty);
        let percentageColor;

        if (percentage > 100) {
            percentageColor = 100;
        }
        else {
            percentageColor = percentage;
        }
        return (
            <div style={{ width: '100%', height: '100%', position: 'relative', marginBottom: '0px' }}>
                <LinearProgress
                    variant="determinate"
                    value={percentageColor}
                    style={{ width: '100%', height: '100%', position: 'absolute', }}
                    color={
                        percentageColor < 25 ? 'error' : // Red color for less than 25%
                            percentageColor <= 70 ? 'warning' : // Yellow color for 25% to 70%
                                'success' // Green color for above 70%
                    }
                />
                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                >
                    {percentage.toFixed(2)} %
                </Typography>
            </div>
        );
    };

    const getStatusProperties = (status) => {
        let label, color, icon, borderColor;

        switch (status) {
            case 'New':
                label = 'New';
                color = '#33691e';
                icon = <ScheduleIcon />;
                borderColor = '#1976d2';
                break;
            case 'Processed':
                label = 'Processed';
                color = '#689f38';
                icon = <PublishedWithChangesIcon />;
                borderColor = '#388e3c';
                break;
            case 'UnderAmendment':
                label = 'Under Amendment';
                color = '#455a64';
                icon = <Amendicon />;
                borderColor = '#f57c00';
                break;
            case 'Cancelled':
                label = 'Cancelled';
                color = '#ff7043';
                icon = <CancelIcon1 />;
                borderColor = '#d32f2f';
                break;
            case 'Approved':
                label = 'Approved';
                color = '#009688';
                icon = <CheckCircleOutlineIcon />;
                borderColor = '#689f38';
                break;
            case 'Invoiced':
                label = 'Invoiced';
                color = '#2e7d32';
                icon = <ReceiptIcon />;
                borderColor = '#689f38';
                break;
            default:
                label = 'Unknown';
                color = '#9e9e9e'; // Grey color
                icon = null;
                borderColor = '#757575';
        }

        return { label, color, icon, borderColor };
    };

    const StatusCell = ({ value }) => {
        const { label, color, icon, borderColor } = getStatusProperties(value);
        return (
            <Chip
                label={label}
                style={{ backgroundColor: color, color: '#fff', height: '80%', borderColor: borderColor }}
                icon={icon}
            />
        );
    };



    useEffect(() => {
        const handleResize = () => {
            setGridAutoRows(calculateGridAutoRows());
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        CalculateSummaryForProducts();
    });


    useEffect(() => {
        LoadPartyList();
        LoadConfirmedOrderList();

    }, []);

    function calculateGridAutoRows() {
        const screenHeight = window.innerHeight;
        const rows = Math.floor((screenHeight - 70) / 3); // Adjust 50 as needed for margins or paddings
        return `${rows}px`;
    }



    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);

        const updatedReelRows = rowsReelItems.map(row => {
            // Find the corresponding row in rowsSheetItemsFiltered
            const filteredRow = rowsReelItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            // If the filtered row exists and matches the condition, update the SelectItem property
            if (filteredRow && filteredRow.id === row.id) {
                // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                // If the filtered row doesn't exist or doesn't match, keep the row as it is
                return row;
            }
        });
        setrowsReelItems(updatedReelRows);

        const updatedsheetRows = rowsSheetItems.map(row => {
            const filteredRow = rowsSheetItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            if (filteredRow && filteredRow.id === row.id) {
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                return row;
            }
        });

        setrowsSheetItems(updatedsheetRows);

    };

    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            // LoadInoviceOrderList();
        }
    };

    const handleSubmitConfirmationOrder = (event) => {
        event.preventDefault();

        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            LoadConfirmedOrderList();
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleKeyPress = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'c') {
            handleCreateDispatchPlans();
        }
        if (event.altKey && event.key.toLowerCase() === 'p') {
            handleBackTofromConnfrimOrderList();
        }
        if (event.altKey && event.key.toLowerCase() === 'n') {
            handleShowDispatchPlansEntry();
        }
        if (event.altKey && event.key.toLowerCase() === 'b') {
            handleBackTofromDespacthPlanEntry();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleCreateDispatchPlans, handleBackTofromConnfrimOrderList, handleShowDispatchPlansEntry, handleBackTofromDespacthPlanEntry]);


    const handleCheckboxChange = (event, rowId) => {
        if (SLength > 0) {
            const updatedRows = rowsSheetItemsFiltered.map(row =>
                row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
            );
            setrowsSheetItemsFiltered(updatedRows);
        }
        else {
            const updatedRows = rowsReelItemsFiltered.map(row =>
                row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
            );
            setrowsReelItemsFiltered(updatedRows);
        }
    };

    const handleSelectAllCheckboxChange = (event) => {
        let updatedRows;

        if (SLength > 0) {
            updatedRows = rowsSheetItemsFiltered.map(row => ({ ...row, SelectItem: event.target.checked }));
            setrowsSheetItemsFiltered(updatedRows);
        } else {
            updatedRows = rowsReelItemsFiltered.map(row => ({ ...row, SelectItem: event.target.checked }));
            setrowsReelItemsFiltered(updatedRows);
        }
    };
    const handleCheckboxChangeForConfirmationOrder = (event, rowId) => {
        const updatedRows = rowsConfirmedOrders.map(row =>
            row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
        );
        setrowsConfirmedOrders(updatedRows);

        const filteredData = updatedRows.filter(row => row.SelectItem === true);
        setselectCOOrders(filteredData);
    };

    const handleSelectAllCheckboxChange_ConfirmationOrder = (event) => {
        let updatedRows;

        updatedRows = rowsSheetItems.map(row => ({ ...row, SelectItem: event.target.checked }));
        setrowsConfirmedOrders(updatedRows);
        filterData_ConfirmedOrders(updatedRows);
    };

    const areAllRowsSelected_ConfirmationOrder = () => {
        return rowsConfirmedOrders.every(row => row.SelectItem);
    };
    function validateItemList() {
        let isFormDataValid = false;

        rowsConfirmedOrdersDespacth.forEach((row) => {
            if (row.SIUnitPrice === 0) {
                showError("Unit price is a required field", "error");
                isFormDataValid = true;
                return;
            } else if (row.SIDiscount === 0 && row.SIDiscountType !== "0" && row.SIDiscountType !== "") {
                showError("Discount value is a required field", "error");
                isFormDataValid = true;
                return;
            } else if (row.SIDiscount > 0 && (row.SIDiscountType === "0" || row.SIDiscountType === "")) {
                showError("Discount type is a required field", "error");
                isFormDataValid = true;
                return;
            }
        });

        return isFormDataValid;
    }


    const handleCancelInvoice = (e) => {
        e.preventDefault();

        try {
            let formDirty = false;

            if (!formDirty) {
                if (cancelDate === '') {
                    showError('Cancel date is a required field', 'error');
                    return;
                }
                else if (Reason === '') {
                    showError('Cancel Reason is a required field', 'error');
                    SetcancelReasonFoucs(true);
                    return;
                }
                else {
                    const confirm = window.confirm(`Are you sure want to Cancel this order?, Confirm Cancellation`);

                    if (!confirm) {
                        return;
                    }

                    setOpenAlert(false);
                    setLoading(true);

                    const formattedDate = dayjs(cancelDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

                    const clsInvoiceOrder = {
                        DespatchOrderId: iDespatchOrderIdList,
                        ShippedOrderId: iShippedOrderIdList,
                        InvoiceOrderId: iInvoiceOrderIdList,
                        ConfirmationOrderId: iConfirmationIdList,
                        SInvoiceNo: SInvoiceNo,
                        SOrderStatus: "Cancelled",
                        SCancelledReason: Reason,
                        InvoicePlanNo: IParentInvoiceOrder_ID,
                        SCancelledDate: formattedDate
                    };

                    const requestBody = {
                        clsInvoiceOrder: clsInvoiceOrder,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.CancelInvoiceOrderDetails, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to cancel invoice')
                            }
                            return response.json();
                        })
                        .then(data => {
                            showError(data.returnmsg, 'success');
                            LoadPartyList();
                            RefreshStatus(data.clsInvoiceOrder.SOrderStatus);
                        })
                        .catch(error => {
                            showError('Unable to cancel invoice.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);

        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    }

    let ApproveAndAmend;
    const handleApproveAndAmendInvoice = (e) => {
        e.preventDefault();

        try {
            let formDirty = false;


            if (e.currentTarget.ariaLabel === 'Approve Invoice') {
                const confirm = window.confirm(`This will Approve the order for invoice creation. Would you like to continue?, Approve Order`);

                if (!confirm) {
                    return;
                }
                ApproveAndAmend = 'Approve';
            }
            else if (e.currentTarget.ariaLabel === 'Amend Invoice') {
                const confirm = window.confirm(`This will allow amendment for the order. Would you like to continue?, Amend Order`);

                if (!confirm) {
                    return;
                }
                ApproveAndAmend = 'Amend';

                if (SAmendmentReason === '') {
                    formDirty = showError('Amendment Reason is a required field', 'error');
                    SetamendmentReasonFoucs(true);
                }
            }

            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {


                    setOpenAlert(false);
                    setLoading(true);

                    handleSaveInvoiceOrder(false)(e);


                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);

        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    }

    const handleSaveInvoiceOrder = (param) => (e) => {
        e.preventDefault();

        try {
            let formDirty = false;
            formDirty = validateItemList();

            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {
                    setOpenAlert(false);
                    setLoading(true);

                    const formattedOrderDate = dayjs(OrderDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
                    const formattedScheduleDate = dayjs(ScheduleDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

                    const clsInvoiceOrder = {
                        DespatchOrderIdList: iDespatchOrderIdList,
                        ShippedOrderIdList: iShippedOrderIdList,
                        InvoiceOrderIdList: iInvoiceOrderIdList,
                        ConfirmationOrderIdList: iConfirmationIdList,
                        SParentInvoiceOrder_ID: IParentInvoiceOrder_ID,
                        SInvoiceNo: SInvoiceNo,
                        SInvoiceDate: formattedOrderDate,
                        SBillToCustomer: SParentCompany,
                        SShipToCustomer: SSalesPerson,
                        SSupplier: 0,
                        SManufacturer: 0,
                        SRefNo: SRefNo,
                        LastUpdatedBy: LOGIN_USER,
                        SRemarks: Remarks,
                        SScheduledDate: formattedScheduleDate,
                        SPriceList: PartyRoleid,
                        SPaymentTerm: Id_PaymentTerm,
                        STransporter: SCountry,
                        SShipmentMode: Id_PartyType,
                        SCreditTerm: Id_CreditTerm,
                        SCreditLimitRule: Id_CreditTermRule,
                        SLocation: 0,
                        TotalQty: totalSIConfirmedQty,
                        BasicAmount: totalGrossAmount,
                        GrossAmount: totalGrossAmount,
                        DiscountAmount: totaldiscountAmount,
                        GrossAmountAfterDiscount: totalAmount,
                        InsuranceRate: 0,
                        InsuranceAmount: 0,
                        FreightPerMT: 0,
                        FreightAmount: 0,
                        ServiceChargeRate: 0,
                        ServiceChargesAmount: 0,
                        TaxableAmount: 0,
                        CessAmount: 0,
                        TaxAmount: 0,
                        NetAmountRoundOff: 0,
                        NetAmountRounded: 0,
                        CessRate: 0,
                        CGSTRate: 0,
                        SGSTRate: 0,
                        IGSTRate: 0,
                        CGSTAmount: 0,
                        SGSTAmount: 0,
                        IGSTAmount: 0,
                        SSalesOrderItems: rowsConfirmedOrdersDespacth,
                    };

                    const requestBody = {
                        clsInvoiceOrder: clsInvoiceOrder,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.saveInvoiceOrderDetails, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to save invoice order')
                            }
                            return response.json();
                        })
                        .then(data => {
                            if (param) {
                                showError(data.returnmsg, 'success');
                            }
                            let parentInvoiceOrderID;
                            setbtnSaveText(data.BtnText);
                            setbtnSaveTooltip(data.BtnText, ' Invoice');
                            set_IParentInvoiceOrder_ID(data.clsInvoiceOrder.SParentInvoiceOrder_ID)
                            parentInvoiceOrderID = data.clsInvoiceOrder.SParentInvoiceOrder_ID;
                            LoadPartyList();
                            LoadConfirmedOrderList();
                            RefreshStatus('New');

                            if (param === false) {
                                const formattedOrderDate = dayjs(OrderDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
                                const formattedScheduleDate = dayjs(ScheduleDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

                                const clsInvoiceOrder = {
                                    DespatchOrderIdList: iDespatchOrderIdList,
                                    ShippedOrderIdList: iShippedOrderIdList,
                                    InvoiceOrderIdList: iInvoiceOrderIdList,
                                    ConfirmationOrderIdList: iConfirmationIdList,
                                    SInvoiceNo: SInvoiceNo,
                                    SParentInvoiceOrder_ID: parentInvoiceOrderID,
                                    InvoicePlanNo: parentInvoiceOrderID,
                                    SInvoiceDate: formattedOrderDate,
                                    SBillToCustomer: SParentCompany,
                                    SShipToCustomer: SSalesPerson,
                                    SSupplier: 0,
                                    SManufacturer: 0,
                                    SRefNo: SRefNo,
                                    LastUpdatedBy: LOGIN_USER,
                                    SRemarks: Remarks,
                                    SScheduledDate: formattedScheduleDate,
                                    SPriceList: PartyRoleid,
                                    SPaymentTerm: Id_PaymentTerm,
                                    STransporter: SCountry,
                                    SShipmentMode: Id_PartyType,
                                    SCreditTerm: Id_CreditTerm,
                                    SCreditLimitRule: Id_CreditTermRule,
                                    SLocation: 0,
                                    TotalQty: totalSIConfirmedQty,
                                    BasicAmount: totalGrossAmount,
                                    GrossAmount: totalGrossAmount,
                                    DiscountAmount: totaldiscountAmount,
                                    GrossAmountAfterDiscount: totalAmount,
                                    InsuranceRate: 0,
                                    InsuranceAmount: 0,
                                    FreightPerMT: 0,
                                    FreightAmount: 0,
                                    ServiceChargeRate: 0,
                                    ServiceChargesAmount: 0,
                                    TaxableAmount: 0,
                                    CessAmount: 0,
                                    TaxAmount: 0,
                                    NetAmountRoundOff: 0,
                                    NetAmountRounded: 0,
                                    CessRate: 0,
                                    CGSTRate: 0,
                                    SGSTRate: 0,
                                    IGSTRate: 0,
                                    CGSTAmount: 0,
                                    SGSTAmount: 0,
                                    IGSTAmount: 0,
                                    SAmendmentReason: SAmendmentReason,
                                    SSalesOrderItems: rowsConfirmedOrdersDespacth,
                                };

                                const requestBody = {
                                    ApproveAndAmend: ApproveAndAmend,
                                    clsInvoiceOrder: clsInvoiceOrder,
                                    bOrderInvoiced, bOrderInvoiced,
                                    ConstructedGlobalValues: {
                                        COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                                        COMPANY_ID: CompanyID,
                                        LOGIN_USER: LOGIN_USER
                                    },
                                };

                                fetch(API_ENDPOINTS.approve_amend_InvoiceOrderDetails, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(requestBody),
                                })
                                    .then(response => {
                                        if (!response.ok) {
                                            throw new Error('Unable to approve Invoice order')
                                        }
                                        return response.json();
                                    })
                                    .then(data => {
                                        showError(data.returnmsg, 'success');

                                        LoadPartyList();
                                        RefreshStatus(data.clsInvoiceOrder.SOrderStatus);
                                    })
                                    .catch(error => {
                                        showError('Unable to approve Invoice order.!', 'error');
                                    });
                            }
                        })
                        .catch(error => {
                            showError('Unable to save invoice order.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {

            console.error('Error:', error);

        } finally {

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };

    const handleGenerateInvoiceOrder = (e) => {
        e.preventDefault();

        try {
            let formDirty = false;



            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {
                    setOpenAlert(false);
                    setLoading(true);

                    const formattedOrderDate = dayjs(OrderDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
                    const formattedScheduleDate = dayjs(ScheduleDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

                    const clsInvoiceOrder = {
                        SOrderStatus: headerDespatchplan,
                        DespatchOrderIdList: iDespatchOrderIdList,
                        ShippedOrderIdList: iShippedOrderIdList,
                        InvoiceOrderIdList: iInvoiceOrderIdList,
                        ConfirmationOrderIdList: iConfirmationIdList,
                        InvoicePlanNo: IParentInvoiceOrder_ID,
                        SParentInvoiceOrder_ID: IParentInvoiceOrder_ID,
                        SInvoiceNo: SInvoiceNo,
                        SInvoiceDate: formattedOrderDate,
                        SBillToCustomer: SParentCompany,
                        SShipToCustomer: SSalesPerson,
                        SSupplier: 0,
                        SManufacturer: 0,
                        SRefNo: SRefNo,
                        LastUpdatedBy: LOGIN_USER,
                        SRemarks: Remarks,
                        SScheduledDate: formattedScheduleDate,
                        SPriceList: PartyRoleid,
                        SPaymentTerm: Id_PaymentTerm,
                        STransporter: SCountry,
                        SShipmentMode: Id_PartyType,
                        SCreditTerm: Id_CreditTerm,
                        SCreditLimitRule: Id_CreditTermRule,
                        SLocation: 0,
                        TotalQty: totalSIConfirmedQty,
                        BasicAmount: totalGrossAmount,
                        GrossAmount: totalGrossAmount,
                        DiscountAmount: totaldiscountAmount,
                        GrossAmountAfterDiscount: totalAmount,
                        InsuranceRate: 0,
                        InsuranceAmount: 0,
                        FreightPerMT: 0,
                        FreightAmount: 0,
                        ServiceChargeRate: 0,
                        ServiceChargesAmount: 0,
                        TaxableAmount: 0,
                        CessAmount: 0,
                        TaxAmount: 0,
                        NetAmountRoundOff: 0,
                        NetAmountRounded: 0,
                        CessRate: 0,
                        CGSTRate: 0,
                        SGSTRate: 0,
                        IGSTRate: 0,
                        CGSTAmount: 0,
                        SGSTAmount: 0,
                        IGSTAmount: 0,
                        SSalesOrderItems: rowsConfirmedOrdersDespacth,
                    };

                    const requestBody = {
                        DocumentSeries: DocumentSeries,
                        clsInvoiceOrder: clsInvoiceOrder,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },

                        filter: {
                            FinancierYear: FinancierYear,
                            CompanyID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.GenerateInvoiceOrder, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to generate invoice order')
                            }
                            return response.json();
                        })
                        .then(data => {
                            if (data.returnmsg === 'This Invoice No Generated Successfully') {
                                showError(data.returnmsg, 'success');
                            }
                            else {
                                showError(data.returnmsg, 'error');
                            }
                            SetSInvoiceNo(data.clsInvoiceOrder.SInvoiceNo);
                            setbtnSaveText(data.BtnText);
                            setbtnSaveTooltip(data.BtnText, ' Invoice');

                            LoadPartyList();
                            LoadConfirmedOrderList();

                            RefreshStatus('Invoiced');
                        })
                        .catch(error => {
                            showError('Unable to save invoice order.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };

    // Function to get today's date
    const getToday = () => {
        return dayjs(); // Returns the current date
    };

    return (
        <Box  >
            <CustomSnackbar
                open={snackbarOpen}
                message={alertMessage}
                onClose={handleSnackbarClose}
                type={alertsevierity}
            />

            <Box m='10px' display="flex" backgroundColor='' justifyContent="space-between" mt={3} mb={3} alignItems="center">
                {/* <Header title="Despatch Plan Management" /> */}
                <Typography variant='h3' fontWeight={'bold'}>Pary Master </Typography>
            </Box>

            {loading && (
                <Box sx={{ width: '100%', marginTop: '10px' }}>
                    <LinearProgress
                        variant="buffer"
                        sx={{
                            '& .MuiLinearProgress-barColorPrimary': {
                                backgroundColor: '#4CAF50', // Green color (you can replace this with your desired color)
                            },
                            '& .MuiLinearProgress-bar2Buffer': {
                                backgroundColor: '#8BC34A', // Another shade of green for the buffer
                            },
                        }}
                        value={progress}
                        valueBuffer={buffer}
                    />
                </Box>
            )}

            <Divider style={{ marginBottom: "0px" }} />

            {isVisible_DespatchPlan && (
                <form onSubmit={handleSubmit}>
                    <Box>
                        <Box margin='0px 10px 0px 10px' display="flex" justifyContent="space-between" alignItems="center">
                            <Box>
                                <Typography mt={2} mb={0} variant="h4" style={{ fontWeight: 'bold' }}>
                                    Party List
                                </Typography>

                                <Typography variant="h6" mb={0} style={{ color: '#B0B8C4' }}>
                                    Select the party to edit the details
                                </Typography>
                            </Box>
                            <Box>
                                <Tooltip title="Create Party [Alt + C]" >
                                    <Button
                                        variant='contained'
                                        style={{ marginRight: '2px', backgroundColor: '#1769aa', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                                        size='small'
                                        startIcon={<PersonAddAltIcon />}
                                        onClick={handleCreateDispatchPlans}
                                    >
                                        New
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Import Party" >
                                    <Button
                                        variant='contained'
                                        style={{ backgroundColor: '#2e7d32', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                                        size='small'
                                        startIcon={<FileDownloadOutlinedIcon />}
                                    >
                                        Import
                                    </Button>
                                </Tooltip>
                            </Box>
                        </Box>

                        <Box
                            margin='5px 10px 0px 10px'
                            gridAutoRows={'530px'}
                            display="grid"
                            gridTemplateColumns="repeat(20, 1fr)"
                            gap={{ xs: '50px', sm: '50px', md: '50px', lg: '10px', xl: '10px' }}
                        >
                            <Box
                                gridColumn="span 20"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{
                                    "& .custom-header": {
                                        fontWeight: 'bold',  // set bold font
                                        fontSize: '0.85rem',  // adjust font size                                 
                                    },
                                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                        color: `${colors.grey[100]} !important`,
                                    },
                                    "& .MuiCheckbox-root": {
                                        color: `${colors.greenAccent[200]} !important`,
                                    },
                                }}
                            >
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pageSize={5}
                                    rowHeight={30}
                                    slots={{ toolbar: GridToolbar }}
                                    slotProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                        },
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </form>
            )}

            {isVisible_commanButtons && (
                <Box>
                    <Box m='0px' display="flex" justifyContent={'space-between'}>
                        <Typography variant="h3" style={{ margin: '10px' }}>
                            {headerDespatchplan}
                        </Typography>

                        <Tooltip title="Close" >
                            <IconButton onClick={handleBackTofromDespacthPlanEntry}>
                                <CancelIcon style={{ color: "#ef5350" }} />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Divider style={{ marginBottom: "1px" }} />
                </Box>
            )}


            {isVisible_CreateDespatchPlan && (
                <Box m='10px'>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            
                            <Card variant='outlined' style={{
                                marginBottom: "5px", marginTop: "5px", borderRadius: '5px 5px 5px 5px',
                            }}>

                                <Card>
                                    <Typography variant="h5" style={{ fontWeight: 550, padding: '10px' }} >
                                        Party Header
                                    </Typography>
                                </Card>

                                <CardContent style={{ marginLeft: '5px' }}>
                                    <Grid
                                        mt={1}
                                        container
                                        spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                    >
                                        {/* First Autocomplete */}
                                        <Grid item xs={3} sm={1} md={1} lg={1} xl={1}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} marginTop={0}>
                                                Party Type
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                                            <Autocomplete
                                                size="small"

                                                fullWidth
                                                value={selectedPartyType}
                                                onChange={handleSelectPartyType}
                                                options={dataPartyType}
                                                getOptionLabel={(option) => option.Description || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Type"
                                                        error={transporterError && transporterError.length ? true : false}
                                                        required
                                                        helperText={transporterError}
                                                        variant="outlined"

                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid ml={2} mt={1} item xs={1} sm={1} md={1} lg={0.7} xl={1}>
                                            <Typography variant="h6" >
                                                Status
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>

                                            <FormGroup>
                                                <FormControlLabel required control={<Switch defaultChecked color="secondary" />} label="Active" />


                                            </FormGroup>
                                        </Grid>


                                    </Grid>

                                    <Grid
                                        style={{ marginTop: '5px' }}
                                        container
                                        spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                    >
                                        <Grid item xs={3} sm={1} md={1} lg={1} xl={1}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Party Role
                                            </Typography>
                                        </Grid>

                                        {/* Second Autocomplete */}
                                        <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                            <Autocomplete
                                                size="small"
                                                fullWidth
                                                value={selectedPartyRole}
                                                onChange={handleSelectPartyRole}
                                                options={dataPartyRole}
                                                getOptionLabel={(option) => option.Description || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Role"
                                                        error={transporterError && transporterError.length ? true : false}
                                                        required
                                                        helperText={transporterError}
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        style={{ marginTop: '5px' }}
                                        container
                                        spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                    >
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Code
                                            </Typography>
                                        </Grid>
                                        {/* Second Autocomplete */}
                                        <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                                            <TextField fullWidth size="small" variant="outlined"
                                                label="Code"
                                                disabled
                                                value={SInvoiceNo}
                                                onChange={(e) => SetSInvoiceNo(e.target.value)}
                                                InputProps={{
                                                    readOnly: true,
                                                }} />
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        style={{ marginTop: '5px' }}
                                        container
                                        spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                    >
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Name
                                            </Typography>
                                        </Grid>
                                        {/* Second Autocomplete */}
                                        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                            <TextField fullWidth size="small" required onChange={handleSelectPoNo} value={SRefNo} label="Name" variant="outlined" />
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        style={{ marginTop: '5px' }}
                                        container
                                        spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                    >
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                Unit
                                            </Typography>
                                        </Grid>
                                        {/* Second Autocomplete */}
                                        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                            <TextField fullWidth size="small" required onChange={handleSelectPoNo} value={SRefNo} label="Unit" variant="outlined" />
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        style={{ marginTop: '5px' }}
                                        container
                                        spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                    >
                                        <Grid item xs={3} sm={1} md={1} lg={1} xl={1}>
                                            <Typography variant="h6"  >
                                                GST No
                                            </Typography>
                                        </Grid>
                                        {/* Second Autocomplete */}
                                        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                            <TextField fullWidth size="small" required onChange={handleSelectPoNo} value={SRefNo} label="GST No." variant="outlined" />
                                        </Grid>

                                    </Grid>
                                </CardContent>
                            </Card>


                            <Box mt={1} sx={{ bgcolor: 'background.paper', }}>
                                <AppBar position="static">
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        // variant="fullWidth"
                                        aria-label="full width tabs example"
                                    >
                                        <Tab label="Other Details" {...a11yProps(0)} />
                                        <Tab label="Address" {...a11yProps(1)} />
                                        {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
                                    </Tabs>
                                </AppBar>
                                <SwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                >
                                    <TabPanel value={value} index={0} dir={theme.direction}>

                                        <Grid
                                            style={{ marginTop: '0px' }}
                                            container
                                            spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                        >
                                            <Grid item xs={4} sm={1} md={1} lg={1.5} xl={1.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    Payment term
                                                </Typography>
                                            </Grid>
                                            {/* Second Autocomplete */}
                                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                <Autocomplete
                                                    size='small'
                                                    fullWidth
                                                    value={selectedPaymentTerm}
                                                    onChange={handleSelectPaymentTerm}
                                                    options={dataPaymentterm}
                                                    getOptionLabel={(option) => option.Description || ''}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Payment term" variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>



                                        </Grid>


                                        <Grid
                                            style={{ marginTop: '5px' }}
                                            container
                                            spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                        >
                                            <Grid item xs={4} sm={1} md={1} lg={1.5} xl={1.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    Credit term
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                <Autocomplete
                                                    size='small'
                                                    fullWidth
                                                    value={selectedCreditTerm}
                                                    onChange={handleSelectCreditTerm}
                                                    options={dataCreditterm}
                                                    getOptionLabel={(option) => option.Description || ''}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Credit term" variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid
                                            style={{ marginTop: '5px' }}
                                            container
                                            spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                        >
                                            <Grid item xs={5} sm={1} md={1} lg={1.5} xl={1.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    Credit term rule
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                <Autocomplete
                                                    size='small'
                                                    fullWidth
                                                    value={selectedCreditTermRule}
                                                    onChange={handleSelectCreditTermRule}
                                                    options={dataCredittermRule}
                                                    getOptionLabel={(option) => option.Description || ''}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Credit term rule" variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>


                                        <Grid
                                            style={{ marginTop: '5px' }}
                                            container
                                            spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                        >
                                            <Grid item xs={5} sm={1} md={1} lg={1.5} xl={1.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    Parent Company</Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                <Autocomplete

                                                    size='small'
                                                    fullWidth
                                                    value={selectedParentCompany}
                                                    onChange={handleSelectParentCompany}
                                                    options={dataParentCompany}
                                                    getOptionLabel={(option) => option.Description || ''}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Parent Compmay" variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>



                                        <Grid
                                            style={{ marginTop: '5px' }}
                                            container
                                            spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                        >
                                            <Grid item xs={1} sm={1} md={1} lg={1.5} xl={1.5}>
                                                <Typography variant="h6" >
                                                    Notes
                                                </Typography>
                                            </Grid>
                                            {/* Second Autocomplete */}
                                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>

                                                <TextField
                                                    size="small"
                                                    onChange={handleSelectPoNo} value={SRefNo}
                                                    label="Notes"
                                                    multiline
                                                    rows={3} // You can adjust the number of rows as needed
                                                    fullWidth
                                                    variant="outlined"
                                                />

                                            </Grid>



                                        </Grid>

                                        <Grid
                                            mb={5}
                                            style={{ marginTop: '5px' }}
                                            container
                                            spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                        >
                                            <Grid item xs={5} sm={1} md={1} lg={1.5} xl={1.5}>
                                                <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                    Sales Handler
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                <Autocomplete
                                                    size='small'
                                                    fullWidth
                                                    value={selectedSalesPerson}
                                                    onChange={handleSelectSalesPerson}
                                                    options={dataSalesPerson}
                                                    getOptionLabel={(option) => option.Description || ''}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Sales Handler" variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>


                                    </TabPanel>
                                    <TabPanel value={value} index={1} dir={theme.direction}>


                                        <Grid container spacing={0}>

                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >

                                                <Grid
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >

                                                    <Grid item xs={7.5} sm={7.5} md={7.5} lg={7.5} xl={7.5}>
                                                        <Typography variant="h5" mb={2} style={{ fontWeight: 550 }} >
                                                            Billing Address
                                                        </Typography>
                                                    </Grid>

                                                    <Grid mt={1} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                        <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                            Status
                                                        </Typography>
                                                    </Grid>

                                                
                                                    <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>

                                                        <FormGroup>
                                                            <FormControlLabel required control={<Switch defaultChecked color="secondary" />} label="Active" />


                                                        </FormGroup>
                                                    </Grid>
                                                </Grid>







                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Address
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            size="small"
                                                            required
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Address Line 1"
                                                            multiline
                                                            rows={2} // You can adjust the number of rows as needed
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>

                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            {/* Address Line 2 */}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Address Line 2"
                                                            multiline
                                                            rows={2} // You can adjust the number of rows as needed
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            City
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            size="small"
                                                            required
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="City"
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Country
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <Autocomplete
                                                            size='small'
                                                            fullWidth
                                                            value={selectedCountry}
                                                            onChange={(event, newValue) => setSelectedCountry(newValue)}
                                                            // onChange={handleSelectCountry}
                                                            options={dataCountry}
                                                            getOptionLabel={(option) => option['Country Name'] || ''}
                                                            renderInput={(params) => (
                                                                <TextField {...params} required label="Country" variant="outlined" />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            State
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <Autocomplete
                                                            required
                                                            size='small'
                                                            fullWidth
                                                            value={selectedCreditTermRule}
                                                            onChange={handleSelectCreditTermRule}
                                                            options={dataCredittermRule}
                                                            getOptionLabel={(option) => option.Description || ''}
                                                            renderInput={(params) => (
                                                                <TextField {...params} required label="State" variant="outlined"
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Pincode
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            required
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Pincode"
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={3} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Fax No
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Fax No"
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={3} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Phone No
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Phone No 1"
                                                            fullWidth
                                                            variant="outlined"

                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <LocalPhoneOutlinedIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />


                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Phone No 2"
                                                            fullWidth
                                                            variant="outlined"

                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <LocalPhoneOutlinedIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={3} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Email ID
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label=" Email ID 1"
                                                            fullWidth
                                                            variant="outlined"

                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <EmailOutlinedIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label=" Email ID 2"
                                                            fullWidth
                                                            variant="outlined"

                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <EmailOutlinedIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >

                                                <Grid
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >

                                                    <Grid item xs={7.5} sm={7.5} md={7.5} lg={7.5} xl={7.5}>
                                                        <Typography variant="h5" mb={2} style={{ fontWeight: 550 }} >
                                                            Shipping Address (<span fontSize='8px' style={{ color: 'lightblue' }}>


                                                                <IconButton style={{ borderRadius: '0px', marginRight: '0px' }}>
                                                                    <ArrowDownwardIcon style={{ color: "#1976d2" }} />
                                                                    <Typography variant="button" fontSize={'14px'} style={{ fontWeight: 'bold', textTransform: 'none', color: '#1976d2' }}> Copy billing address</Typography>
                                                                </IconButton>


                                                            </span>)
                                                        </Typography>
                                                    </Grid>

                                                    <Grid mt={1} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                        <Typography variant="h6" fontWeight="" fontStyle={''} >
                                                            Status
                                                        </Typography>
                                                    </Grid>

                                                
                                                    <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>

                                                        <FormGroup>
                                                            <FormControlLabel required control={<Switch defaultChecked color="secondary" />} label="Active" />


                                                        </FormGroup>
                                                    </Grid>
                                                </Grid>

                                                <Grid

                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Address
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            size="small"
                                                            required
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Address Line 1"
                                                            multiline
                                                            rows={2} // You can adjust the number of rows as needed
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>

                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            {/* Address Line 2 */}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Address Line 2"
                                                            multiline
                                                            rows={2} // You can adjust the number of rows as needed
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            City
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            size="small"
                                                            required
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="City"
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                </Grid>


                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Country
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <Autocomplete
                                                            size='small'
                                                            fullWidth
                                                            value={selectedCreditTermRule}
                                                            onChange={handleSelectCreditTermRule}
                                                            options={dataCredittermRule}
                                                            getOptionLabel={(option) => option.Description || ''}
                                                            renderInput={(params) => (
                                                                <TextField {...params} required label="Country" variant="outlined"
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>


                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            State
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <Autocomplete
                                                            required
                                                            size='small'
                                                            fullWidth
                                                            value={selectedCreditTermRule}
                                                            onChange={handleSelectCreditTermRule}
                                                            options={dataCredittermRule}
                                                            getOptionLabel={(option) => option.Description || ''}
                                                            renderInput={(params) => (
                                                                <TextField {...params} required label="State" variant="outlined"
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Pincode
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            required
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Pincode"
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={3} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Fax No
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Fax No"
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={3} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Phone No
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Phone No 1"
                                                            fullWidth
                                                            variant="outlined"


                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <LocalPhoneOutlinedIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Phone No 2"
                                                            fullWidth
                                                            variant="outlined"

                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <LocalPhoneOutlinedIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px' }}
                                                    container
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={3} sm={2} md={2} lg={2} xl={2}>
                                                        <Typography variant="h6" >
                                                            Email ID
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label=" Email ID 1"
                                                            fullWidth
                                                            variant="outlined"

                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <EmailOutlinedIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                                        <TextField
                                                            size="small"
                                                            onChange={handleSelectPoNo} value={SRefNo}
                                                            label="Email ID 2"
                                                            fullWidth
                                                            variant="outlined"
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <EmailOutlinedIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    style={{ marginTop: '5px', marginBottom: '25px' }}
                                                    container
                                                    justifyContent="flex-end" // Align content to the end
                                                    alignContent="end"
                                                    spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                                                >
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        {/* <FormGroup>
                                                            <FormControlLabel required control={<Checkbox defaultChecked color="success" />} label="Shipping Address Same As Billing Address" />
                                                        </FormGroup> */}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    {/* <TabPanel value={value} index={2} dir={theme.direction}>
                                        Item Three
                                    </TabPanel> */}
                                </SwipeableViews>
                            </Box>
                        </Grid>
                    </Grid>

                    <AppBar
                        position="fixed"
                        // color="primary"
                        style={{
                            top: 'auto',
                            height: '55px',
                            bottom: 0,
                            // backgroundColor: '#212121'
                        }}
                    >
                        <Toolbar>
                            <Button
                                variant='contained'
                                style={{ marginLeft: 'auto', marginRight: '5px', backgroundColor: '#1769aa', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                                size='small'
                                startIcon={<SaveOutlined />}
                            >
                                Save
                            </Button>

                            <Button
                                variant='contained'
                                style={{ marginRight: '0px', backgroundColor: '#607d8b', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                                size='small'
                                startIcon={<Close />}
                            >
                                Cancel
                            </Button>

                        </Toolbar>
                    </AppBar>
                </Box>
            )}

            {
                isVisible_DespatchItem && (
                    <Box m='0px'>
                        {open && (
                            <div style={{
                                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backdropFilter: 'blur(2px)', // Adjust the blur intensity
                                zIndex: 1000, // Adjust the z-index to be above other content
                            }}
                            ></div>
                        )}

                        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" >
                            <DialogContent padding={0} style={{ padding: '0px', margin: '0px', backgroundColor: theme.palette.background.default }}>
                                <Card style={{ borderRadius: '5px 5px 5px 5px', backgroundColor: "transparent", marginBottom: "0px", marginTop: "0px" }}>
                                    <Box
                                        sx={{
                                            backgroundColor: '#295254',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#FFFFFF', // Adjust font color based on theme mode
                                        }}
                                    >
                                        <Typography variant="h5" fontWeight={''} padding={1} >  Select the Items for Delivery Order</Typography>

                                        <Tooltip title="Close" onClick={handleClose}>
                                            <IconButton>
                                                <CancelIcon style={{ color: "#ef5350" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>

                                    <CardContent style={{ padding: 2, borderRadius: '5px 5px 5px 5px', backgroundColor: "transparent", }}>
                                        <Box
                                            display="grid"
                                            gridTemplateColumns="repeat(20, 1fr)"
                                            gridAutoRows="500px"
                                            gap="0px"
                                        >
                                            <Box
                                                gridColumn="span 20"
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{
                                                    "& .custom-header": {
                                                        fontWeight: 'bold',  // set bold font
                                                        fontSize: '0.85rem',  // adjust font size                                 
                                                    },
                                                    borderRadius: '15px 15px 15px 15px',
                                                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                                        color: `${colors.grey[100]} !important`,
                                                    },
                                                    "& .MuiCheckbox-root": {
                                                        color: `${colors.greenAccent[200]} !important`,
                                                    },
                                                }}
                                            >
                                                {isVisibleReelItem && (
                                                    <DataGrid
                                                        style={{ marginTop: '0px' }}
                                                        rows={rowsReelItemsFiltered || []}
                                                        columns={columnsReelItems}
                                                        // checkboxSelection
                                                        rowHeight={30}
                                                        pageSize={5}
                                                        slots={{ toolbar: GridToolbar }}
                                                        slotProps={{
                                                            toolbar: {
                                                                showQuickFilter: true,
                                                            },
                                                        }}

                                                    />
                                                )}

                                                {isVisibleSheetItem && (
                                                    <DataGrid
                                                        style={{ marginTop: '0px' }}
                                                        rows={rowsSheetItemsFiltered || []}
                                                        columns={columnsSheetItems}
                                                        // checkboxSelection
                                                        rowHeight={30}
                                                        pageSize={5}
                                                        slots={{ toolbar: GridToolbar }}
                                                        slotProps={{
                                                            toolbar: {
                                                                showQuickFilter: true,
                                                            },
                                                        }}

                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </DialogContent>
                        </Dialog>
                    </Box>
                )
            }
        </Box >
    );
};

export default PartyMaster;